import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { ErrorResponse, Response } from '@/types';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export const patchPasswordReset = ({
  password,
  passwordConfirmation,
  resetPasswordToken,
}: {
  password: string;
  passwordConfirmation: string;
  resetPasswordToken: string;
}): Promise<Response> => {
  const requestBody: Record<string, Exclude<string | boolean, null>> = {
    password,
    passwordConfirmation,
    resetPasswordToken,
  };

  return axios.patch('/api/v1/auth/password', requestBody);
};

type QueryFnType = typeof patchPasswordReset;

type Options = {
  config?: MutationConfig<QueryFnType>;
};

export const usePatchPasswordReset = ({ config }: Options = {}) => {
  return useMutation({
    ...config,
    mutationFn: (args) => patchPasswordReset(args),
    onError: (error: AxiosError<ErrorResponse>) => {
      return error.response?.data;
    },
  });
};
